import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
// obj key
// refreshToken vux中刷新token的函数
// filterUrl Array 不需要拦截的请求路径
export function interceptors(axios, store, router, obj) {
  // 防止重复刷新
  var isRefreshing = false;
  // 缓存token失效后 所有接口
  var subscribers = [];

  // 刷新 token 后, 将缓存的接口重新请求一次
  function onAccessTokenFetched(newToken) {
    subscribers.forEach(function (callback) {
      return callback(newToken);
    });
    subscribers = [];
  }

  // 添加缓存接口
  function addSubscriber(callback) {
    subscribers.push(callback);
  }
  axios.interceptors.response.use(function (response) {
    var data = response.data,
      config = response.config;
    var fliterFlag = obj.filtersUrl ? !obj.filtersUrl.some(function (item) {
      return config.url.includes(item);
    }) : true;

    // 判断是否是 Token 失效错误，并且这个请求需要拦截
    if (data.code === 'A0230' && fliterFlag) {
      if (!isRefreshing) {
        isRefreshing = true;
        return store.dispatch(obj.refreshToken).then(function (res) {
          var newToken = res.result.jwt_token;
          onAccessTokenFetched(newToken);
          return retryRequest(config, newToken);
        }).catch(function (err) {
          // 刷新token报错的话, 就需要跳转到登录页面
          store.dispatch('user/logoutClear');
          router.push('/login?redirect=dashboard');
          return Promise.reject(err);
        }).finally(function () {
          isRefreshing = false;
        });
      }

      // 这里是将其他接口缓存起来的关键, 返回Promise并且让其状态一直为等待状态,
      // 只有当token刷新成功后, 就会调用通过addSubscriber函数添加的缓存接口,
      // 此时, Promise的状态就会变成resolve
      return new Promise(function (resolve) {
        addSubscriber(function (newToken) {
          resolve(retryRequest(config, newToken));
        });
      });
    }
    return response;
  });
  function retryRequest(config, token) {
    var newConfig = _objectSpread({}, config);
    newConfig.headers.Authorization = "bearer ".concat(token);
    return axios(newConfig);
  }
}